export type AppRole =
  | 'ROLE_ADMIN'
  | 'ROLE_MODERATOR'
  | 'ROLE_PRODUCT_MANAGER'
  | 'ROLE_SALES_MANAGER'
  | 'ROLE_SALES_REP';

export const ADMIN_ROLE: AppRole = 'ROLE_ADMIN';
export const MODERATOR_ROLE: AppRole = 'ROLE_MODERATOR';
export const PRODUCT_MANAGER_ROLE: AppRole = 'ROLE_PRODUCT_MANAGER';
export const SALES_MANAGER_ROLE: AppRole = 'ROLE_SALES_MANAGER';
export const SALES_REP_ROLE: AppRole = 'ROLE_SALES_REP';

export const getUserRoles = (user: { roles?: string[] } | null): string[] =>
  user?.roles ?? [];
